import { useContext } from 'react';
import { SocketContext } from '../context/SocketContext';

function useSocket() {
  return useContext(SocketContext);
}

export default useSocket;
